var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header .menu');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('touchstart click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
    });
}


// Sticky menu
//-----------------------------------------------------------------
mp.stickyMenu = function () {

    var $element = $('.header');

    setSticky();

    $(window).scroll(function(){
        setSticky();
    });

    function setSticky() {
        if ($(window).scrollTop() > 100) {
            $element.addClass('scrolled');
        } else {
            $element.removeClass("scrolled");
        }
    }
}


$(document).ready(function(){
    mp.MenuToggle();
    //mp.stickyMenu();
});